import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IForgotPasswordUpdateEmailReqBody, IForgotPasswordVerifyPinEntity } from '../../../entity';

export interface IForgotPasswordUpdatePasswordByEmailUseCase {
    execute(reqBody: IForgotPasswordUpdateEmailReqBody): Promise<IForgotPasswordVerifyPinEntity>;
}

export class ForgotPasswordUpdatePasswordByEmailUseCase implements IForgotPasswordUpdatePasswordByEmailUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(reqBody: IForgotPasswordUpdateEmailReqBody): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.userRepo.forgotPasswordUpdatePasswordByEmail(reqBody);
    }
}
